import React, { useCallback, useEffect, useMemo, useState } from "react";
import Header from "../common/Header";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  RiFile2Fill,
  RiArrowGoBackFill,
  RiArrowLeftLine,
  RiCloseCircleFill,
  RiDraftFill,
  RiMapPinLine,
  RiVideoChatFill,
  RiLink,
  RiCheckFill,
  RiWindow2Fill,
  RiFileTextLine,
  RiFileCopy2Fill,
  RiShareBoxFill,
  RiFileTransferFill,
} from "react-icons/ri";
import { BsSlashCircle } from "react-icons/bs";
import { FaFileSignature, FaReceipt, FaRetweet } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../common/ButtonComponent";
import TableComponent from "../common/TableComponent";
import BreadcrumbComponent from "../common/BreadcrumbComponent";
import ConfirmPopup from "../common/ConfirmPopup";
import InfoPopup from "../common/InfoPopup";
import useModel from "../../hooks/useModel";
import AuditTrialPopup from "../common/AuditTrailPopup";
import { useAppDispatch } from "../../hooks/hooks";
import AlertMessage from "../common/AlertMessage";
import ErrorMessageAlert, { useAlert } from "../common/Alert";
import {
  forceCreateArrestWarrant,
  forceCreateProbableCauseStatement,
  getEcomplaintMainDetails,
getInitialPreTrialData,
  submitForReviewWithSupervisor,
  tackBack,
  undoCertification,
  updateElementValueComplaintMainReducer,
  useComplaintMainReducer,
  forceCreateSummon,
  getLoggedInUserCountiesForLFC,
  getEcomplaintMainDetailsFromDUCS,
  getCaseAssignmentStatus,
  fileWithCircuitClerk,
} from "../../redux/slice/complaintMainSlice";
import { loginUser, useLoginReducer } from "../../redux/slice/loginSlice";
import { TableActionComponent } from "../common/TableActionComponent";
import {
  previewEcomplaint,
  previewArrestWarrent,
  previewPreTrialRelease,
  probableCauseStatementPreview,
  victimInfoPreview,
  summonsPreview,
  previewComplaintReceipt
} from "../../redux/slice/commonFormSlice";
import {
  getVideoConferenceURL,
  updateElementValueVideoConferenceReducer,
} from "../../redux/slice/videoConferenceSlice";
import VideoConferenceSplitScreenPopUp from "../warrantlist/form/VideoConferenceSplitScreenPopUp";
import {
  editComplaint,
  takeComplaintBack,
  deleteForms,
  updateLockById,
  useComplaintDashReducer,
  updateElementValuecomplaintDashReducer,
  resubmitAccordingToTheFormType,
  editComplaintFromSummons,
    resubmitComplaint
} from "../../redux/slice/ecomplaintDashboardSlice";
import {
  LF_SEND_TO_JUDGE_STATUS,
  LF_REJECTED_STATUS,
  LF_VOID_STATUS,
  LF_ARREST_WARRANT,
  LF_COMPLAINT,
  ROLE_JUDGE,
  ROLE_ADMINISTRATOR,
  ROLE_POLICE_OFFICER,
  ROLE_AGENCY_ADMIN,
  ROLE_COUNTY_ADMIN,
  LF_DELETED_STATUS,
  CREATE_LF_FORM_ARREST_WARRANT,
  LF_PENDING_STATUS,
  LF_FORM_TYPE_COMPLAINT,
  LF_IMPOUND_ORDER,
  LF_NOTICE_OF_ARREST_WITHOUT_WARRANT,
  LF_SIGNED_STATUS,
  LF_RETURNED_STATUS,
  LF_SEND_TO_SA_STATUS,
  LF_COMPLETE_STATUS,
  LF_FILED_STATUS,
  LF_ARRW_SIGNED_STATUS,
  FETCH_LF_MAIN_DETAILS_FROM_DASHBOARD,
  PREVIEW_LF_COMPLAINT_FROM_DASHBOARD,
  PREVIEW_LF_COMPLAINT_FROM_VIDEO_CONFERENCE,
  ROLE_STATES_ATTORNEY,
  ROLE_SA_ADMIN,
  LF_SEND_TO_OFFICER_STATUS,
  LF_STATUS_PENDING_SUPERVISOR_REVIEW,
  LF_STATUS_PENDING_SUPERVISOR_RETURNED,
  PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE,
  LF_COMPLAINT_PROCESSING,
  REVISED_PROBABLE_CAUSE_STATEMENT,
  FETCH_LF_MAIN_DETAILS_FROM_ARRESTWARRANT,
  AUDIT_TYPE_ACCESS,
  AUDIT_TYPE_MODIFICATION,
  VICTIM_INFO,
  TYPE_OF_ARREST_ONVIEWARREST,
  CREATE_LF_FORM_SUMMON,
  FETCH_LF_MAIN_DETAILS_FROM_SUMMON,
  LF_COMMUNI_FAILED_STATUS,
  DUCS_CMS_SUPPORT,
  LF_BENCH_WARRANT,
  LF_REQUIRED_STATUS,
  LF_ARRW_RETURNED_STATUS,
  LF_COMPLAINT_ECFORM_IMAGE_UPLOAD_SUCCESS
} from "../../constants/common";
import {
  getUpdatesEcOfficersFromIucs,
    updateElementValueComplaintReducer,
  useComplaintReducer,
} from "../../redux/slice/complaintSlice";

import {
  fetchArrestWarrant,
  returnToOfficerArrestWarrant,
  saveArrestWarrant,
  setECFormData,
  updateAwState,
  updateElementObjectValueArrestWarrantReducer,
  useArrestWarrantReducer,
} from "../../redux/slice/arrestWarrantSlice";
import { PreTrialReleaseRecognizanceProps, updateElementValuePreTrialReleaseRecognizanceReducer, updatePreTrialReleaseRecognizanceObject, usePreTrialReleaseRecognizance } from "../../redux/slice/preTrialReleaseRecognizanceSlice";
import { fetchProbableCauseStatementData } from "../../redux/slice/probableCauseStatementSlice";
import {
  fetchAuditTrailData,
  fetchAuditTrailDataForLongForm,
  useAuditTrailReducer,
} from "../../redux/slice/auditTrailSlice";
import {
  useDashboardReducer,
  updateElementValueDashboardReducer,
} from "../../redux/slice/dashboardSlice";
import { updateSummonState, returnToOfficerSummons, useSummonsReducer} from "../../redux/slice/summonsSlice";
import RemarkPopup from "../common/RemarkPopup";
import OptionPopup from "../common/OptionsPopup";



interface ResubmitComplaintPopupState {
  show?: boolean;
  message?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

interface EComplaintDashBoardProps {}
function isAllowPreview(caseStatus: string, formType: string, formStatus: String, system: string) {
  if (system === DUCS_CMS_SUPPORT && formType === LF_COMPLAINT) {
    return false;
  }
  if (LF_VOID_STATUS === caseStatus || LF_DELETED_STATUS === caseStatus) {
    return false;
  }

  if (CREATE_LF_FORM_SUMMON === formType){
    if(LF_COMMUNI_FAILED_STATUS === formStatus) return false;
    else return true;
  }
  // KHL PR-11814 09/01/2025 START
  if (formType === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE) {
    return formStatus === LF_COMPLETE_STATUS;
  }
  // KHL PR-11814 09/01/2025 END
  if (
    LF_COMPLAINT === formType ||
    LF_NOTICE_OF_ARREST_WITHOUT_WARRANT === formType ||
    PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE === formType ||
    REVISED_PROBABLE_CAUSE_STATEMENT === formType ||
    CREATE_LF_FORM_ARREST_WARRANT === formType ||
    LF_IMPOUND_ORDER === formType ||
    VICTIM_INFO === formType ||
    CREATE_LF_FORM_SUMMON
  ) {
    return true;
  }
  return false;
}

function isAllowReturn(userType: string, formStatus: string, formType: string, system: string) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_ARREST_WARRANT === formType || CREATE_LF_FORM_SUMMON === formType) {
    if (
      (ROLE_JUDGE === userType && LF_SEND_TO_JUDGE_STATUS === formStatus) ||
      (ROLE_AGENCY_ADMIN === userType &&
        LF_STATUS_PENDING_SUPERVISOR_REVIEW === formStatus)
    ) {
      return true;
    }
  }
  return false;
}

function isAllowReturnComplaint(
  userType: string,
  formType: string,
  formStatus: string,
  isOnViewArrest: boolean,
  system: string
) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (
    LF_STATUS_PENDING_SUPERVISOR_REVIEW === formStatus &&
    userType === ROLE_AGENCY_ADMIN &&
    isOnViewArrest &&
    !(
      LF_NOTICE_OF_ARREST_WITHOUT_WARRANT === formType ||
      LF_ARREST_WARRANT === formType ||
      CREATE_LF_FORM_SUMMON === formType ||
      LF_IMPOUND_ORDER === formType
    )
  ) {
    return true;
  }
  return false;
}

function isAllowReject(userType: string, formStatus: string, formType: string, system: string) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_ARREST_WARRANT === formType || CREATE_LF_FORM_SUMMON === formType) {
    if (ROLE_JUDGE === userType && LF_SEND_TO_JUDGE_STATUS === formStatus) {
      return true;
    }
  }
  return false;
}

function isAllowSign(userType: string, formStatus: string, formType: string, system: string) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_ARREST_WARRANT === formType  || CREATE_LF_FORM_SUMMON === formType) {
    if (ROLE_JUDGE === userType && LF_SEND_TO_JUDGE_STATUS === formStatus) {
      return true;
    }
  }
  return false;
}

function isAllowVoid(
  userType: string,
  formStatus: string,
  formType: string,
  caseNumber: string,
  system: string
) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_COMPLAINT === formType && LF_VOID_STATUS !== formStatus) {
    if (
      (ROLE_POLICE_OFFICER === userType || ROLE_AGENCY_ADMIN === userType) &&
      (!caseNumber || caseNumber.trim() === "")
    ) {
      return true;
    }
    if (
      (ROLE_ADMINISTRATOR === userType || ROLE_COUNTY_ADMIN === userType) &&
      (!caseNumber || caseNumber.trim() === "")
    ) {
      return true;
    }
  }
  return false;
}

function isAllowDelete(
  compStatus: string,
  userType: string,
  formType: string,
  formStatus: string,
  canDeleteEComplaint: any,
  system: string
) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_COMPLAINT === formType) {
    if (canDeleteEComplaint && LF_DELETED_STATUS !== formStatus) {
      return true;
    }
  } else if (
    ROLE_POLICE_OFFICER === userType &&
    LF_ARREST_WARRANT === formType
  ) {
    if (LF_FILED_STATUS === compStatus && LF_SIGNED_STATUS !== formStatus) {
      return true;
    }
  } else if (PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE === formType && LF_COMPLETE_STATUS !== formStatus){
     return true;
  }
  return false;
}

function isAllowAudit(formType: string, auditTrailSecurity: any, system: string) {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (LF_COMPLAINT === formType && auditTrailSecurity) {
    return true;
  } else {
    return false;
  }
}

function isAllowViewEdit(
  compStatus: string,
  formType: string,
  formStatus: string,
  userType: string,
  system: string
) {
  if (system === DUCS_CMS_SUPPORT && formType === LF_ARREST_WARRANT) {
    return false;
  }
  if (LF_COMPLAINT === formType && LF_COMPLAINT_PROCESSING !== compStatus) {
    return true;
  } else if (CREATE_LF_FORM_ARREST_WARRANT === formType || CREATE_LF_FORM_SUMMON === formType) {
    if (
      ROLE_JUDGE === userType &&
      !(
        LF_SIGNED_STATUS === formStatus ||
        LF_REJECTED_STATUS === formStatus ||
        LF_RETURNED_STATUS === formStatus ||
        LF_COMPLAINT_PROCESSING === formStatus 
      )
    ) {
      return true;
    } else if (
      (ROLE_POLICE_OFFICER === userType || ROLE_AGENCY_ADMIN === userType) &&
      LF_SEND_TO_SA_STATUS !== formStatus &&
      (LF_PENDING_STATUS === formStatus ||
        LF_REJECTED_STATUS === formStatus ||
        (LF_RETURNED_STATUS === formStatus &&
          !(
            LF_STATUS_PENDING_SUPERVISOR_RETURNED === compStatus &&
            ROLE_AGENCY_ADMIN === userType
          )) ||
        LF_SEND_TO_JUDGE_STATUS === formStatus ||
        LF_COMPLETE_STATUS === formStatus ||
        LF_VOID_STATUS === formStatus ||
        LF_STATUS_PENDING_SUPERVISOR_REVIEW === formStatus)
    ) {
      return true;
    } else if (
      ROLE_STATES_ATTORNEY === userType &&
      LF_SEND_TO_OFFICER_STATUS !== compStatus &&
      (LF_PENDING_STATUS === formStatus ||
        LF_REJECTED_STATUS === formStatus ||
        LF_RETURNED_STATUS === formStatus ||
        LF_COMPLETE_STATUS === formStatus ||
        LF_VOID_STATUS === formStatus)
    ) {
      return true;
    } else if (ROLE_COUNTY_ADMIN === userType || ROLE_ADMINISTRATOR === userType) {
      if (LF_FILED_STATUS === compStatus && LF_SIGNED_STATUS === formStatus) {
        return true;
      }
      else if(LF_COMMUNI_FAILED_STATUS === formStatus){
        return true;
      }
    } else if (LF_DELETED_STATUS === formStatus) {
      return true;
    }
  } else if (REVISED_PROBABLE_CAUSE_STATEMENT === formType) {
    if (
      (ROLE_POLICE_OFFICER === userType || ROLE_STATES_ATTORNEY === userType) &&
      LF_PENDING_STATUS === formStatus
    ) {
      return true;
    }
  }
  return false;
}

const isAllowResubmit = (
  formStatus: string,
  formType: string,
  canResubmitEcomplaint: boolean,
  countyIntegratedWithCMS: boolean,
  preTrialReleaseUploadFailed: boolean,
  probableCauseUploadFailed: boolean,
  system: string
) => {
  if (system === DUCS_CMS_SUPPORT && (formType === LF_ARREST_WARRANT || formType ===  LF_COMPLAINT)) {
    return false;
  }
  if (
    formType === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE ||
    formType === REVISED_PROBABLE_CAUSE_STATEMENT ||
    formType === VICTIM_INFO
  ) {
    if (
      formStatus === LF_COMPLETE_STATUS &&
      canResubmitEcomplaint &&
      countyIntegratedWithCMS
    ) {
      if (preTrialReleaseUploadFailed || probableCauseUploadFailed) {
        return true;
      }
    }
  }
  return false;
};
const isAllowResubmitComplaint = (
  formStatus: string,
  formType: string,
  canResubmitEcomplaint: boolean,
  countyIntegratedWithCMS: boolean,

) => {
 
  if  (!countyIntegratedWithCMS || !canResubmitEcomplaint ||formType !== LF_COMPLAINT ){
    return false;
  }
  if (formStatus=== LF_FILED_STATUS || formStatus === LF_COMMUNI_FAILED_STATUS) {
    return true;
  }
  //   if (
  //     formStatus === LF_COMPLETE_STATUS &&
  //     canResubmitEcomplaint &&
  //     countyIntegratedWithCMS
  //   ) {

   
  // }}
  return false;
};


const isAllowResubmitForm = (
  formStatus: string,
  formType: string,
  canResubmitEcomplaint: boolean,
  countyIntegratedWithCMS: boolean,
  complaintCaseStatus:string, 
) => {  //   return false;

    if  (!countyIntegratedWithCMS || !canResubmitEcomplaint ){
    return false;
  }
    if (
    formType === LF_NOTICE_OF_ARREST_WITHOUT_WARRANT ||
    formType === LF_IMPOUND_ORDER ||
    formType === VICTIM_INFO|| 
    formType ===  LF_COMPLAINT
  ) {
    return false;
  }
  if(complaintCaseStatus !== LF_FILED_STATUS){
    return false; 
  }
   if (
    formStatus === LF_COMPLETE_STATUS ||
    formStatus === LF_COMMUNI_FAILED_STATUS ||
    formStatus === LF_COMPLAINT_PROCESSING||
    formStatus === LF_SIGNED_STATUS
  ){
   return true;
  }
  return false;
};

const isAllowTakeBack = (
  formStatus: string,
  comStatus: string,
  userRole: string,
  system: string
) => {
  if (system === DUCS_CMS_SUPPORT) {
    return false;
  }
  if (
    (ROLE_POLICE_OFFICER === userRole || ROLE_AGENCY_ADMIN === userRole) &&
    (LF_SEND_TO_JUDGE_STATUS === comStatus ||
      LF_SEND_TO_JUDGE_STATUS === formStatus ||
      LF_STATUS_PENDING_SUPERVISOR_REVIEW === comStatus ||
      LF_STATUS_PENDING_SUPERVISOR_REVIEW === formStatus)
  ) {
    return true;
  }
  return false;
};

// KHL PR 11594 02/10/25 - START
function isAllowApprove(userType: string, formStatus: string, formType: string, system: string) {
  if ((formType === LF_ARREST_WARRANT || formType === CREATE_LF_FORM_SUMMON) 
    && formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW
    && userType === ROLE_AGENCY_ADMIN)
    {
      return true;
    } else {
      return false;
    }
}
// KHL PR 11594 02/10/25 - END

const isSupervisor = (userType: string) => {
  if (ROLE_AGENCY_ADMIN === userType) {
    return true;
  }
  return false;
};

function isAllowUnlock(lockedBy: string, userRole: string, userName: string) {
  if (userRole === ROLE_JUDGE && lockedBy && lockedBy === userName) {
    return true;
  }
}

const EComplaintDashBoard: React.FC<EComplaintDashBoardProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const arrestWarrantReducer = useArrestWarrantReducer();
  const summonWarrantReducer = useSummonsReducer();
  const complaintReducer = useComplaintMainReducer();
  const preTrialReducer = usePreTrialReleaseRecognizance();
  const { complaintObject } = useComplaintReducer();
  const ecomplaintReducer = useComplaintMainReducer();
  const loginReducer = useLoginReducer();
  const createdcomplaint = useComplaintReducer();
  const { successMessage, failureMessage, importFrom } = useComplaintDashReducer();
  const { statechangeMsg, lfcCountyList } = useComplaintMainReducer();
  const complaintMainReducer = useComplaintMainReducer();
  const { userType, canViewAuditTrail, canDeleteEComplaint } =
    useLoginReducer();
  const videoConferencePopup = useModel();
  const [confirmText, setconfirmText] = React.useState<React.ReactNode>();
  const [confirmOriginPlace, setconfirmOriginPlace] = React.useState("");
  const [statechangeMsgVal, setStatechangeMsgVal] = React.useState("");
  const [successMessageVal, setSuccessMessageVal] = React.useState("");
  const [confirmPopupData, setconfirmPopupData] = React.useState({
    show: false,
    ecObj: {},
  });
  const [showInfoPopup, setShowInfoPopup] = React.useState({
    show: false,
    info: "",
    variant: "info",
  });
  const [showVideoConference, setShowVideoConference] = React.useState(false);
  const errorMessageAlert = useAlert();
  const [errorKeys, setErrorKeys] = useState([""]);
  const complaintMain = useComplaintMainReducer();

  const tableHeader = ["#", "FORMS", "STATUS", "LOCKED BY", "ACTIONS"];

  const [showAuditTrail, setShowAuditTrail] = React.useState(false);
  const [searchWarrantIdForAuditTrail, setSearchWarrantIdForAuditTrail] =
    React.useState(0);
  const [formTypeForAuditTrail, setFormTypeForAuditTrail] = React.useState("");
  const [caseNumberForAuditTrail, setCaseNumberForAuditTrail] =
    React.useState("");
  const [auditType, setAuditType] = React.useState("");

  //KHL PR 11594 01/16/25 - START
  const [viewRemark, setViewRemark] = React.useState("");
  const [onlyView, setOnlyView] = React.useState(false);
  const [remarkModalShow, setRemarkModalShow] = React.useState(false);
  const [remarkModalData, setRemarkModalData] = React.useState({});
  const [remarkRequired, setRemarkRequired] = React.useState(false);
  const [remarkFor, setRemarkFor] = React.useState("");
  const [remark, setRemark] = React.useState("");
  const [isEditClick, setIsEditClick] = React.useState(false);
    const [returnDetails, setReturnDetails] = React.useState({
      eComplaintId: 0,
      formType: "",
      formStatus: "",
      formId: 0,
      remark: "",
    });
  const [action, setAction] = React.useState("");
  //KHL PR 11594 01/16/25 - END
  // KHL PR-11814 09/01/2025 - START
  const [showPreTrialInfoPopup, setShowPreTrialInfoPopup] = useState(false); 
  const [createRemotePreTrial, setCreateRemotePreTrial] = useState(false);
  // KHL PR-11814 09/01/2025 - END  
  // KHL PR 11594 02/10/25 - START
  const [showSubmitToJudge, setShowSubmitToJudge] = React.useState(false);
    const [
      fillingProcessConfirmationModalShow,
      setFillingProcessConfirmationModalShow,
    ] = React.useState(false);
  // KHL PR 11594 02/10/25 - END

  const [approvingFormType, setApprovingFormType] = React.useState("");
  const auditTrailReducer = useAuditTrailReducer();
  const dashboardReducer = useDashboardReducer();
  
  const [showResubmitComplaintPopup, setShowResubmitComplaintPopup] = React.useState<ResubmitComplaintPopupState>({show:false,message:"",onConfirm:()=>{},onCancel:()=>{}});

  const closeResubmitComplaintPopupClose= () => {
    setShowResubmitComplaintPopup({
      show: false,
      message: "",
      onConfirm: () => {},
      onCancel: () => {},
    });
  }

  //KHL PR 1256 06/02/24 - START
  //mount
  useEffect(() => {
    dispatch(getLoggedInUserCountiesForLFC());
  }, []);
  //KHL PR 1256 06/02/24 - END

  const handleError = useCallback(
    (_errorKeys: string[], errorMessages: string[]) => {
      setErrorKeys(_errorKeys);
      errorMessageAlert.handleError(errorMessages);
      window.scroll({ top: 0, behavior: "smooth" });
    },
    []
  );
  //KHL PR 1256 25/01/24 - START
  const ecCountyList = lfcCountyList.filter((county: any) => {
    if (county.countyID !== 0) {
      return county;
    }
  });
  //KHL PR 1256 25/01/24 - END

  //KHL PR 11264 09/01/24 - START
  function isAllowGenerateReceipt(
    compStatus: string,
    formType: string,
    formStatus: string,
    system: string
  ) {
    if (system === DUCS_CMS_SUPPORT) {
      return false;
    }
    if (LF_COMPLAINT === formType) {
      if (LF_FILED_STATUS === compStatus && complaintMainReducer.receiptEnable) {
        return true;
      }else{
        return false;
      }
    }else if(PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE === formType){
      if (formStatus === LF_COMPLETE_STATUS && complaintMainReducer.receiptEnable) {
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }
  //KHL PR 11264 09/01/24 - END

  // KHL PR-11814 09/01/2025 - START
  useEffect(()=>{
    if (ecomplaintReducer.fetchCaseAssignmentStatus === "success") {
        let obj: PreTrialReleaseRecognizanceProps = {
        ...preTrialReducer.pretiralData,
        defForeignAddress: complaintReducer.complaint.defForeignAddress? "Y": "N",
        defAddressLine1: complaintReducer.complaint.defAddressLine1 === null? "": complaintReducer.complaint.defAddressLine1,
        defAddressLine2: complaintReducer.complaint.defAddressLine2 === null? "": complaintReducer.complaint.defAddressLine2,
        defCity: complaintReducer.complaint.defCity === null? "": complaintReducer.complaint.defCity,
        defState: complaintReducer.complaint.defState === null? "": complaintReducer.complaint.defState,
        defZip: complaintReducer.complaint.defZip === null? "": complaintReducer.complaint.defZip,
        defCountry: complaintReducer.complaint.defCountry === null? "": complaintReducer.complaint.defCountry,
        radioDcnCollectedNo: complaintReducer.complaint.dcn === null? "Y": "N",
        radioDcnCollectedYes: complaintReducer.complaint.dcn === null? "N": "Y",
        documentControlNumber: complaintReducer.complaint.dcn === null? "": complaintReducer.complaint.dcn,
      }
        dispatch(updatePreTrialReleaseRecognizanceObject(obj))
        dispatch(updateElementValuePreTrialReleaseRecognizanceReducer({elementName: "importFrom", value: DUCS_CMS_SUPPORT}));  

      if (ecomplaintReducer.caseAssignmentStatus === "ASSIGNED") {
        navigate('/PreTrialReleaseOnOwnRecognizPage');
      }
      else {
      setShowPreTrialInfoPopup(true); 
      setCreateRemotePreTrial(true);
      }
      dispatch(updateElementValueComplaintMainReducer({elementName: "fetchCaseAssignmentStatus", value: "idle"}));
    }
  },[ecomplaintReducer.fetchCaseAssignmentStatus]);
 // KHL PR-11814 09/01/2025 -END

  useEffect(() => {
    if (failureMessage) {
      handleError([], [failureMessage]);
      dispatch(
        updateElementValuecomplaintDashReducer({
          elementName: "failureMessage",
          value: "",
        })
      );
    }
  }, [failureMessage, dispatch, handleError]);

  useEffect(() => {
    if (statechangeMsg && statechangeMsg.length > 0) {
      setStatechangeMsgVal(statechangeMsg);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      dispatch(
        updateElementValueComplaintMainReducer({
          elementName: "statechangeMsg",
          value: "",
        })
      );
    }
  }, [statechangeMsg]);

  useEffect(() => {
    if (successMessage) {
      setSuccessMessageVal(successMessage);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      dispatch(
        updateElementValuecomplaintDashReducer({
          elementName: "successMessage",
          value: "",
        })
      );
    }
  }, [successMessage]);

  useEffect(() => {
    if (importFrom === DUCS_CMS_SUPPORT && createdcomplaint.tempECId === 0 )
      dispatch(getEcomplaintMainDetailsFromDUCS({caseNumber: createdcomplaint.tempCaseNumber}));
    else {
      dispatch(
        getEcomplaintMainDetails({
          ecomplaintId:
            createdcomplaint.tempECId === 0
              ? complaintReducer.complaint.ecomplaintId
              : createdcomplaint.tempECId,
          callingFrom: FETCH_LF_MAIN_DETAILS_FROM_DASHBOARD,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (Array.isArray(complaintReducer.ecFormList)) {
      const arrestWarrant = complaintReducer.ecFormList.find(
        (item: any) => item.formTypeName === LF_ARREST_WARRANT
      );
  
      const summonForm = complaintReducer.ecFormList.find(
        (item: any) => item.formTypeName === CREATE_LF_FORM_SUMMON
      );
  
      if (arrestWarrant?.formData) {
        updateAwStateForArrestWarrant();
      }
  
      if (summonForm?.formData) {
        updateSummonStateForSummonPage();
      }
    }
  }, [complaintReducer.ecFormList, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        updateElementValueComplaintReducer({
          elementName: "navigateFrom",
          value: "",
        })
      );
    };
  }, []);

// KHL PR-11814 09/01/2025 START
  const hidePopupFlag =  complaintReducer.hidePopupFlag;
  useEffect(() => {
    if (preTrialReducer.createStatus == "success" && !hidePopupFlag) {
      setShowPreTrialInfoPopup(true);
        dispatch(
          updateElementValuePreTrialReleaseRecognizanceReducer({
            elementName: "createStatus",
            value: "idle",
          })
        );
        dispatch(updateElementValueComplaintMainReducer({ 
          elementName: "hidePopupFlag", 
          value: true 
        })
      );
    }
  }, [preTrialReducer.createStatus, hidePopupFlag]);
  // KHL PR-11814 09/01/2025 END
  // KHL PR-11814 10/01/2025 START
  useEffect(() => {
    if(preTrialReducer.createStatus == "success" && preTrialReducer.assignmentStatus === "UNAUTHORIZED LOGIN"){
    const alertMessage = "An error occurred in the Clerk's Case Management System. Please contact an authorized person.";
      setShowInfoPopup({ show: true, info: alertMessage,variant: "danger" });
      setShowPreTrialInfoPopup(false);      
    }
  },[preTrialReducer.createStatus]);
  // KHL PR-11814 10/01/2025 END

  const backToEcomplaintList = () => {
    dispatch(
      updateElementValueDashboardReducer({
        elementName: "isCardActive",
        value: false,
      })
    );
    const url = dashboardReducer.PreviousURLLFC;
    const newUrl = url.replace(/^.*\/\/.*?\//, "");
    navigate("/" + newUrl);
  };

  const onBreadcrumbClick = () => {
    dispatch(
      updateElementValueDashboardReducer({
        elementName: "isCardActive",
        value: false,
      })
    );
  };

  const updateAwStateForArrestWarrant = () => {
    if (complaintReducer.ecFormList instanceof Array) {
      const arrestWarrant = complaintReducer.ecFormList.find(
        (item: any) => item.formTypeName === LF_ARREST_WARRANT
      );
      if (arrestWarrant) {
        if (arrestWarrant.formData) {
          dispatch(updateAwState("edit"));
        } else {
          dispatch(updateAwState("createFromDashBoard"));
        }
      }
    }
  };

  const updateSummonStateForSummonPage = () => {
    if (complaintReducer.ecFormList instanceof Array) {
      const summon = complaintReducer.ecFormList.find(
        (item: any) => item.formTypeName === CREATE_LF_FORM_SUMMON
      );
      if (summon) {
        if (summon.formData) {
          dispatch(updateSummonState("edit"));
        } else {
          dispatch(updateSummonState("createFromDashBoard"));
        }
      }
    }
  };

  const refreshPage = () => {
    dispatch(
      getEcomplaintMainDetails({
        ecomplaintId: createdcomplaint.tempECId,
        callingFrom: FETCH_LF_MAIN_DETAILS_FROM_DASHBOARD,
      })
    );
  };

  // KHL PR-11814 09/01/2025 START
  const handlePreTrialPopUp = () => {
    if (createRemotePreTrial && importFrom === DUCS_CMS_SUPPORT){
        navigate('/PreTrialReleaseOnOwnRecognizPage');
    }else{
     const ecomplaintId = complaintReducer.complaint.ecomplaintId;
      dispatch(
        getInitialPreTrialData({
          ecomplaintId: ecomplaintId,
          navigate,
          createPreTrial: true,
        })
      );
    }
  }
  // KHL PR-11814 09/01/2025 END

  // function handleECEdit(message: any) {
  //   let confirmText = (
  //     <>
  //       <label>{message}</label>
  //     </>
  //   );
  //   setconfirmText(confirmText);
  //   setconfirmOriginPlace("handleFileEdit");
  // }

  // function handleECTakeBack(message: any) {
  //   let confirmText = (
  //     <>
  //       <label>{message}</label>
  //     </>
  //   );
  //   setconfirmText(confirmText);
  //   setconfirmOriginPlace("handleFileTakeBack");
  // }

  function handleTakeBack(message: string) {
    let confirmText = (
      <>
        <label>{message}</label>
      </>
    );
    setconfirmText(confirmText);
    setconfirmOriginPlace("handleTakeBack");
  }

  function handleECVoid(message: any) {
    let confirmText = (
      <>
        <label>{message}</label>
      </>
    );
    setconfirmText(confirmText);
    setconfirmOriginPlace("handleFileVoid");
  }

  function handleECReturn(message: any) {
    let confirmText = (
      <>
        <label>{message}</label>
      </>
    );
    setconfirmText(confirmText);
    setconfirmOriginPlace("handleECReturn");
  }

  function handleECReject(message: any) {
    let confirmText = (
      <>
        <label>{message}</label>
      </>
    );
    setconfirmText(confirmText);
    setconfirmOriginPlace("handleECReject");
  }

  function handleECDelete(message: any) {
    let confirmText = (
      <>
        <label>{message}</label>
      </>
    );
    setconfirmText(confirmText);
    setconfirmOriginPlace("handleECDelete");
  }

  const onHide = () => {
    dispatch(
      updateElementValueVideoConferenceReducer({
        elementName: "videoConferenceStatus",
        value: "idle",
      })
    );
    setShowVideoConference(false);
  };

  const showVideoConferenceModal = () => {
    // if (
    //   caseDetailReducer.countyAdmonishment != null &&
    //   caseDetailReducer.countyAdmonishment != ""
    // ) {
    //   setShowAdmonishment(true);
    // } else {
    //   onConfirmAdmonishment();
    // }
    let cNumber = "";
    if (complaintReducer.complaint.caseNumber)
      cNumber = complaintReducer.complaint.caseNumber;
    else if (complaintReducer.complaint.complaintNumber)
      cNumber = complaintReducer.complaint.complaintNumber;

    let data = {
      agencyCode: complaintReducer.complaint.officerAgencyCode,
      caseNumber: cNumber,
      searchWarrantId: 0,
      ecomplaintId: complaintReducer.complaint.ecomplaintId,
    };
    dispatch(getVideoConferenceURL(data));
    // this.props.getEcomplaintDocData(this.props.ecomplaintReducer.ecomplaintId, false, PREVIEW_LF_COMPLAINT_FROM_VIDEO_CONFERENCE);
    setShowVideoConference(true);
  };

  const showAuditTrailModal = () => {
    let ecomplaintId = complaintMain.complaint.ecomplaintId;
    let formType = "";
    let caseNumber = complaintMain.complaint.caseNumber;

    let auditObj = {
      ecomplaintId: ecomplaintId,
      auditType: AUDIT_TYPE_ACCESS,
    };
    dispatch(fetchAuditTrailDataForLongForm(auditObj));
    setShowAuditTrail(true);
    setSearchWarrantIdForAuditTrail(ecomplaintId);
    setFormTypeForAuditTrail(formType);
    setCaseNumberForAuditTrail(caseNumber);
    setAuditType(AUDIT_TYPE_ACCESS);
  };

  const afterConfirmOnVoidClick = (obj: any) => {
    let data = {
      formId: obj.formId,
      formType: obj.formType,
      ecomplaintId: obj.ecomplaintId,
      status: LF_VOID_STATUS,
      actionType: "ignoreArrestWarrantData",
      navigate: navigate,
    };
    dispatch(editComplaint(data));
  };

  const afterConfirmOnTakeBackClick = (obj: any) => {
    dispatch(
      takeComplaintBack({
        complaintId: complaintReducer.complaint.ecomplaintId,
        objUse: obj,
        navigate: navigate,
      })
    );
  };

  const afterConfirmOnReturnClick = (obj: any) => {
    if (obj.status === LF_STATUS_PENDING_SUPERVISOR_REVIEW
        && complaintReducer.complaint.typeOfArrest === TYPE_OF_ARREST_ONVIEWARREST
        && complaintReducer.complaint.caseStatus !== LF_FILED_STATUS
    ) {
      let complaintObj = { ...complaintReducer.complaint };
      complaintObj.caseStatus = LF_STATUS_PENDING_SUPERVISOR_RETURNED;

      //KHL PR 11594 01/21/25 - START
      if (returnDetails && returnDetails.remark) {
        const newRemark = {
          remark: "",
          timestamp: "",
        };
        complaintObj.remarkToAdd = returnDetails.remark;
      }
      //KHL PR 11594 01/21/25 - END

      dispatch(
        submitForReviewWithSupervisor({
          ecomplaint: complaintObj,
          navigate: navigate,
        })
      );
    } else {
      if (obj.formType === CREATE_LF_FORM_ARREST_WARRANT) {
        dispatch(
          returnToOfficerArrestWarrant({
            navigate: navigate,
            navigateFrom: "Dashboard",
            formId: obj.formId,
            actionType: "ignoreArrestWarrantData",
            formData: returnDetails             //KHL PR 11594 01/16/25
          })
        );
      }else if (obj.formType === CREATE_LF_FORM_SUMMON) {
        dispatch(
          returnToOfficerSummons({
            navigate: navigate,
            navigateFrom: "Dashboard",
            formId: obj.formId,
            actionType: 'ignoreSummonData',
            formData: returnDetails           //KHL PR 11594 01/16/25
          })
        )
      }
  }
  };

  const afterConfirmOnRejectClick = (obj: any) => {
    if (obj.formType === CREATE_LF_FORM_ARREST_WARRANT) {
      let data = {
        formId: obj.formId,
        formType: obj.formType,
        ecomplaintId: obj.ecomplaintId,
        status: LF_REJECTED_STATUS,
        actionType: "ignoreArrestWarrantData",
        navigate: navigate,
      };
      dispatch(editComplaint(data));
    } else if (obj.formType === CREATE_LF_FORM_SUMMON) {
      let data = {
        formId: obj.formId,
        formType: obj.formType,
        ecomplaintId: obj.ecomplaintId,
        status: LF_REJECTED_STATUS,
        actionType: 'ignoreSummonData',
        navigate: navigate,
      };
      dispatch(editComplaintFromSummons(data));
    }
  };

  const afterConfirmOnDeleteClick = (obj: any) => {
    let data = {
      formId: obj.formId,
      formType: obj.formType,
      ecomplaintId: obj.ecomplaintId,
      status: LF_DELETED_STATUS,
      actionType: "ignoreArrestWarrantData",
      navigate: navigate,
    };
    if (LF_COMPLAINT === data.formType) {
      dispatch(editComplaint(data));
    } else if (LF_ARREST_WARRANT === obj.formType) {
      dispatch(
        deleteForms({
          formId: obj.formId,
          formType: obj.formType,
          ecomplaintId: obj.ecomplaintId,
          status: LF_DELETED_STATUS,
        })
      );
    }
    // KHL PR-11814 09/01/2025 START
    else if(PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE === obj.formType){
      dispatch(
        deleteForms({
          formId: obj.formId,
          formType: obj.formType,
          ecomplaintId: obj.ecomplaintId,
          status: LF_DELETED_STATUS,
          navigate:navigate
        })
      );
    }
    // KHL PR-11814 09/01/2025 END
  };

  // const afterConfirmOnTakeBack = (obj: any) => {
  //   if (obj !== null) {
  //     if (
  //       obj.status !== LF_FILED_STATUS &&
  //       complaintReducer.complaint.onViewArrest
  //     ) {
  //       let data = {
  //         formId: obj.formId,
  //         formType: obj.formType,
  //         ecomplaintId: obj.ecomplaintId,
  //         status: LF_PENDING_STATUS,
  //         navigate: navigate,
  //       };
  //       dispatch(editComplaint(data));
  //     }
  //       let ecForm;
  //       for (const element of complaintReducer.ecFormList) {
  //         if (element.formTypeName === CREATE_LF_FORM_ARREST_WARRANT) {
  //           ecForm = element;
  //         }
  //       }
  //       if (ecForm.formId > 0) {
  //         let container: any = {};
  //         container.className = "Ecomplaint";
  //         let propsValues: any = [];
  //         container.propsValues = propsValues;
  //         let dataObj = {
  //           ecomplaintId: complaintReducer.complaint.ecomplaintId,
  //           ecStatus: LF_COMPLETE_STATUS,
  //           dto: container,
  //           identifier: "takeBack",
  //           navigate: navigate,
  //         };

  //         let undoObj = {
  //           ecomplaintId: complaintReducer.complaint.ecomplaintId,
  //           navigate: navigate,
  //         };
  //         if (LF_FILED_STATUS !== complaintReducer.complaint.caseStatus) {
  //           propsValues.push(["caseStatus", LF_PENDING_STATUS]);
  //           dispatch(undoCertification(undoObj));
  //         }
  //         dispatch(tackBack(dataObj));
  //       }
  //   }
  // };

  const handleConfirmation = () => {
    setconfirmPopupData({ show: false, ecObj: {} });
    if (confirmOriginPlace === "handleTakeBack") {
      afterConfirmOnTakeBackClick(confirmPopupData.ecObj);
    } else if (confirmOriginPlace === "handleFileVoid") {
      afterConfirmOnVoidClick(confirmPopupData.ecObj);
    } else if (confirmOriginPlace === "handleECReturn") {
      afterConfirmOnReturnClick(confirmPopupData.ecObj);
    } else if (confirmOriginPlace === "handleECReject") {
      afterConfirmOnRejectClick(confirmPopupData.ecObj);
    } else if (confirmOriginPlace === "handleECDelete") {
      afterConfirmOnDeleteClick(confirmPopupData.ecObj);
    } else if (confirmOriginPlace === "preTrailCreate") {
      afterConfirmPreTrailCreatd();
    }
    // else if (confirmOriginPlace === "handleTakeBack") {
    //   afterConfirmOnTakeBack(confirmPopupData.ecObj);
    // }
  };

  const afterConfirmPreTrailCreatd = () => {
    if (importFrom === DUCS_CMS_SUPPORT && createdcomplaint.tempECId === 0) {
      dispatch(getCaseAssignmentStatus({ecomplaint: complaintReducer.complaint}))
    }
    else {
      const ecomplaintId = complaintReducer.complaint.ecomplaintId;
      dispatch(
        getInitialPreTrialData({
          ecomplaintId: ecomplaintId,
          navigate,
        })
      );
    }
  }

  const cancelAuditTrailModal = () => {
    setShowAuditTrail(false);
  };

  const onEditClick =
    (
      formType: string,
      formStatus: string,
      formId: number,
      ecomplaintId: number
    ) =>
    () => {
      let objUse: any = {};
      objUse.formId = formId;
      objUse.status = formStatus;
      objUse.formType = formType;
      objUse.ecomplaintId = ecomplaintId;
      let ec_msg_confirm_takeBack =
        "You are about to take this complaint back from the Judge. This will require you to re-submit it after any edits are made.";
      let ec_msg_confirm_takeBack_from_supervisor =
        "You are about to take this complaint back from the Supervisor. This will require you to re-submit it after any edits are made";
      let message;
      if (formType === "Complaint") {
        if (
          isAllowTakeBack(
            formStatus,
            complaintReducer.complaint.caseStatus,
            userType,
            importFrom,
          ) &&
          !(
            isSupervisor(userType) &&
            formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW
          )
        ) {
          if (formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW) {
            message = ec_msg_confirm_takeBack_from_supervisor;
          } else {
            message = ec_msg_confirm_takeBack;
          }

          setconfirmPopupData({
            show: true,
            ecObj: objUse,
          });
          handleTakeBack(message);
        } else {
          navigate("/eComplaintMainPage");
        }
      } else if (formType === "Arrest Warrant") {
        if (
          isAllowTakeBack(
            formStatus,
            complaintReducer.complaint.caseStatus,
            userType,
            importFrom
          ) &&
          !(
            isSupervisor(userType) &&
            formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW
          )
        ) {
          if (formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW) {
            message = ec_msg_confirm_takeBack_from_supervisor;
          } else {
            message = ec_msg_confirm_takeBack;
          }
          setconfirmPopupData({
            show: true,
            ecObj: objUse,
          });
          handleTakeBack(message);
        } else {
          if (
            ROLE_JUDGE === userType &&
            complaintReducer.complaint.caseStatus === LF_FILED_STATUS
          ) {
            const data = {
              formId: formId,
              ecomplaintId: complaintReducer.complaint.ecomplaintId,
              action: "lockArrestWarrant",
            };
            dispatch(updateLockById(data));
          }
          //KHL PR 1256 06/02/24 - START
          if(ecCountyList.filter((county) => county.impoundEnable === true && 
          complaintReducer.complaint.countyName === county.countyName).length > 0){
            dispatch(updateElementObjectValueArrestWarrantReducer({
              elementName: "isImpoundWarrant",
              value: "Y",
            }));
          }
          //KHL PR 1256 06/02/24 - END      
          getEcomplaintMainDetails({
            ecomplaintId: ecomplaintReducer.complaint.ecomplaintId,
            callingFrom: FETCH_LF_MAIN_DETAILS_FROM_ARRESTWARRANT,
          });
          updateAwStateForArrestWarrant();
          dispatch(setECFormData({ status: formStatus, formId }));
          navigate("/arrestWarrant");
        }
      } else if (formType === REVISED_PROBABLE_CAUSE_STATEMENT) {
        let Obj = {
          formId: formId,
          navigate: navigate,
        };
        dispatch(fetchProbableCauseStatementData(Obj));
      } else if (formType === "Summon") {
        if (
          isAllowTakeBack(
            formStatus,
            complaintReducer.complaint.caseStatus,
            userType,
            importFrom
          ) &&
          !(
            isSupervisor(userType) &&
            formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW
          )
        ) {
          if (formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW) {
            message = ec_msg_confirm_takeBack_from_supervisor;
          } else {
            message = ec_msg_confirm_takeBack;
          }
          setconfirmPopupData({
            show: true,
            ecObj: objUse,
          });
          handleTakeBack(message);
        } else {
          if (
            ROLE_JUDGE === userType &&
            complaintReducer.complaint.caseStatus === LF_FILED_STATUS
          ) {
            const data = {
              formId: formId,
              ecomplaintId: complaintReducer.complaint.ecomplaintId,
              action: "lockSummons",
            };
            dispatch(updateLockById(data));
          }
          getEcomplaintMainDetails({
            ecomplaintId: ecomplaintReducer.complaint.ecomplaintId,
            callingFrom: FETCH_LF_MAIN_DETAILS_FROM_SUMMON,
          })
          updateSummonStateForSummonPage();
          dispatch(setECFormData({ status: formStatus, formId }));
          navigate("/issueSummons");
        }
        
      }
    };

  const onVoidClick =
    (
      formId: number,
      ecomplaintId: number,
      formType: string,
      formStatus: string
    ) =>
    () => {
      let objUse: any = {};
      objUse.formId = formId;
      objUse.ecomplaintId = ecomplaintId;
      objUse.status = formStatus;
      objUse.formType = formType;

      let message = "Are you sure you want to VOID this complaint ?";
      setconfirmPopupData({
        show: true,
        ecObj: objUse,
      });
      handleECVoid(message);
    };

  //KHL PR 11594 01/16/25 - START
  const onReturnClick =
    (
      formId: number,
      ecomplaintId: number,
      formType: string,
      formStatus: string
      ) => () => {
      
      setReturnDetails({
        eComplaintId: ecomplaintId,
        formType: formType,
        formStatus: formStatus,
        formId: formId,
        remark: "",
      });

      if(formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW || formStatus === LF_SEND_TO_JUDGE_STATUS       
        && (formType === LF_ARREST_WARRANT || formType === CREATE_LF_FORM_SUMMON || formType === LF_COMPLAINT)
      ){
      setAction("Add Remarks");
      setIsEditClick(false);
      setRemarkRequired(true);
      setRemarkFor("RETURN");
      setRemarkModalShow(true);
      setOnlyView(false);
      setconfirmOriginPlace("onReturnClick");
    }else{
      returnForm("");
    }
    };

    const returnForm = (remark: string) =>
    () => {
      let objUse: any = {};
      objUse.formId = returnDetails.formId;
      objUse.ecomplaintId = returnDetails.eComplaintId;
      objUse.status = returnDetails.formStatus;
      objUse.formType = returnDetails.formType;

        let message = ""
        if (returnDetails.formType === LF_ARREST_WARRANT){
          message =
          "Do you want to return the arrest warrant to the officer without signing the warrant ?";
        }else if (returnDetails.formType === CREATE_LF_FORM_SUMMON){
          message =
          "Do you want to return the summons to the officer without signing the summons ?";
        }

      if (returnDetails.formStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW) {
        if (returnDetails.formType === LF_ARREST_WARRANT){
        message = "Do you want to return the arrest warrant to the officer?";
        }else if (returnDetails.formType === CREATE_LF_FORM_SUMMON){
          message = "Do you want to return the summons to the officer?";
        }else if (returnDetails.formType === LF_COMPLAINT){
          message = "Do you want to return the complaint to the officer?";
        }
      }
      setReturnDetails({ ...returnDetails, remark: remark});
      setconfirmPopupData({
        show: true,
        ecObj: objUse,
      });
      handleECReturn(message);
    };
    //KHL PR 11594 01/16/25 - END

  const onRejectClick =
    (
      formId: number,
      ecomplaintId: number,
      formType: string,
      formStatus: string
    ) =>
    () => {
      let objUse: any = {};
      objUse.formId = formId;
      objUse.ecomplaintId = ecomplaintId;
      objUse.status = formStatus;
      objUse.formType = formType;
      let message = ""
        if (formType === LF_ARREST_WARRANT){
          message =
          "Do you want to reject the arrest warrant without signing the warrant ?";
        }else if (formType === CREATE_LF_FORM_SUMMON){
          message =
          "Do you want to reject the summons without signing the summons ?";
        }
        setconfirmPopupData({
          show: true,
          ecObj: objUse,
        });
        handleECReject(message);
    };

  const onDeleteClick =
    (
      formId: number,
      ecomplaintId: number,
      formType: string,
      formStatus: string,
      lockUserName: string
    ) =>
    () => {
      let alertMessage;
      let objUse: any = {};
      objUse.formId = formId;
      objUse.ecomplaintId = ecomplaintId;
      objUse.status = formStatus;
      objUse.formType = formType;

      if (LF_COMPLAINT === formType) {
        let message = "Are you sure you want to DELETE this complaint ?";
        setconfirmPopupData({
          show: true,
          ecObj: objUse,
        });
        handleECDelete(message);
      } else if (LF_ARREST_WARRANT === formType) {
        if (lockUserName) {
          alertMessage = "Arrest Warrant is Locked for reviewing.";
          setShowInfoPopup({ show: true, info: alertMessage,variant: "info" });
        } else {
          let message = "Are you sure you want to DELETE this Arrest Warrant ?";
          setconfirmPopupData({
            show: true,
            ecObj: objUse,
          });
          handleECDelete(message);
        }
      }
      // KHL PR-11814 09/01/2025 START
      else if(PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE === formType){
          let message = "Are you sure you want to DELETE this PreTrial Release on Own Recognizance ?";
          setconfirmPopupData({
            show: true,
            ecObj: objUse,
          });
          handleECDelete(message);
      }
      // KHL PR-11814 09/01/2025 END
    };

  const onResubmitClick =
    (ecomplaintId: number, fromScheduler: boolean, formType: string,formId: number) => () => {
      let dataObj = {
        ecomplaintId: ecomplaintId,
        fromScheduler: fromScheduler,
        formType: formType,
        formId:0
      };
      dispatch(resubmitAccordingToTheFormType(dataObj));
    };
  
  //KHL PR 11264 09/01/24 - START
  const onReceiptClick = (formType: string, formId: number) => () => {
      dispatch(
        previewComplaintReceipt({
          ecomplaintId: complaintReducer.complaint.ecomplaintId,
          formType: formType,
          formId: formId
        })
      );
  }
  //KHL PR 11264 09/01/24 - END

  const getAuditTrails =
    (ecomplaintId: number, formType: string, caseNumber: string) => () => {
      let auditObj = {
        ecomplaintId: ecomplaintId,
        auditType: AUDIT_TYPE_MODIFICATION,
      };
      dispatch(fetchAuditTrailDataForLongForm(auditObj));
      setShowAuditTrail(true);
      setSearchWarrantIdForAuditTrail(ecomplaintId);
      setFormTypeForAuditTrail(formType);
      setCaseNumberForAuditTrail(caseNumber);
      setAuditType(AUDIT_TYPE_MODIFICATION);
    };
    
    // KHL PR 11594 02/10/25 - START
    const onFilewihClerkClick = () => () => {
      errorMessageAlert.handleError([]);
      let errorMessages: string[] = [];
      if (!complaintReducer.complaint.certificationIndicator) {
        errorMessages.push("Complaint should be certified.");
      } else if (LF_REQUIRED_STATUS === complaintReducer.complaint.caseSaApproved) {
        errorMessages.push("Felony counts must be approved by State's Attorney.");
      } else if (
        LF_REJECTED_STATUS === complaintReducer.complaint.caseSaApproved ||
        containsRejectedCounts()
      ) {
        errorMessages.push("Can not proceed with rejected counts.");
      } 

      if (errorMessages.length > 0) {
        errorMessageAlert.handleError(errorMessages);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      } else {
        setFillingProcessConfirmationModalShow(true);
      }

    }

    const submitToJudgeClick = (formTypeName: string) => () => {
      setApprovingFormType(formTypeName);
      setShowSubmitToJudge(true);
    };

    const containsRejectedCounts = () => {
      for (let i: number = 0; i < countList.length; i++) {
        if (LF_REJECTED_STATUS === countList[i].saApprovalStatus) {
          return true;
        }
      }
      return false;
    };
    // KHL PR 11594 02/10/25 - END

  const handlePreview =
    (formType: string, formId: number, formStatus: string) => () => {
      let alertMessage;
      let data = {
        ecomplaintId: complaintReducer.complaint.ecomplaintId,
        isRedacted: false,
        callingFrom: PREVIEW_LF_COMPLAINT_FROM_DASHBOARD,
      };
            if (formType === LF_FORM_TYPE_COMPLAINT) {
        dispatch(previewEcomplaint(data));
      } else if (formType === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE) {
        dispatch(
          previewPreTrialRelease({
            ecomplaintId: complaintReducer.complaint.ecomplaintId,
            ecFormId: formId,
            formData: {},
          })
        );
      } else if (formType === REVISED_PROBABLE_CAUSE_STATEMENT) {
        dispatch(
          probableCauseStatementPreview({
            ecomplaintId: complaintReducer.complaint.ecomplaintId,
            ecFormId: formId,
            formData: {},
          })
        );
      } else if (
        formStatus === LF_PENDING_STATUS &&
        formType === CREATE_LF_FORM_ARREST_WARRANT
      ) {
        alertMessage = "Arrest Warrant document is not available yet.";
        setShowInfoPopup({ show: true, info: alertMessage,variant: "info" });
      } else if (formType === VICTIM_INFO) {
        dispatch(
          victimInfoPreview({
            ecomplaintId: complaintReducer.complaint.ecomplaintId,
            ecFormId: formId,
            formData: {},
          })
        );
      }else if (formType === CREATE_LF_FORM_SUMMON){
        dispatch(
          summonsPreview({
            ecomplaintId: complaintReducer.complaint.ecomplaintId,
            ecFormId: formId,
            formData: {},
          })
        );
      } else {
        if (importFrom === DUCS_CMS_SUPPORT && createdcomplaint.tempECId === 0) {
          downloadPDF()
        }
        else {
          dispatch(
            previewArrestWarrent({
              ecomplaintId: complaintReducer.complaint.ecomplaintId,
              ecFormId: formId,
              formData: {},
            })
          );
        }
      }
    };

  
  const downloadPDF = () =>{
    const binaryString = atob(complaintReducer.warrantImage);
    const len = binaryString.length;
    const binaryData = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([binaryData], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = "Arrest_Warrant" + ".pdf";
    a.click();
  }

  const handleFormLinkClick = (formName: string) => () => {
    if (formName === CREATE_LF_FORM_ARREST_WARRANT) {
      //KHL PR 1256 25/01/24 - START 
      if(ecCountyList.filter((county) => county.impoundEnable === true && 
      complaintReducer.complaint.countyName === county.countyName).length > 0){
        dispatch(updateElementObjectValueArrestWarrantReducer({
          elementName: "isImpoundWarrant",
          value: "Y",
        }));
      } else {
        dispatch(updateElementObjectValueArrestWarrantReducer({
          elementName: "isImpoundWarrant",
          value: "N",
        }));
      }
      //KHL PR 1256 25/01/24 - END
      dispatch(updateAwState("createFromDashBoard"));
      //navigate("/arrestWarrant"); //Commented by KHL PR-11390 09/25/2025
      let dataObj = {
        ecomplaintId: complaintReducer.complaint.ecomplaintId,
        modifyComplaint: false,
        navigate: navigate,
      };
      dispatch(forceCreateArrestWarrant(dataObj));
    }else if (formName === CREATE_LF_FORM_SUMMON){
      dispatch(updateSummonState("createFromDashBoard"));
      
      let dataObj = {
        ecomplaintId: complaintReducer.complaint.ecomplaintId,
        modifyComplaint: false,
        navigate: navigate,
      };
      dispatch(forceCreateSummon(dataObj))
        .unwrap()  
        .then((response) => { 
          navigate("/issueSummons");
        })
        .catch((error) => {
          console.error("Force create failed:", error);
        });
    } else if (formName === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE) {
      const ecForms = complaintReducer.ecFormList || [];
      if (!ecForms.some((item: any) => item.formTypeName === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE)){
        afterConfirmPreTrailCreatd();
      }
      else {
        setconfirmText("The Pre-Trial Release on own recognizance has already been granted. Do you want to continue?");
        setconfirmPopupData({
          show: true,
          ecObj: {},
        });
        setconfirmOriginPlace("preTrailCreate");
      }
    } else if ((formName = REVISED_PROBABLE_CAUSE_STATEMENT)) {
      const ecomplaintId = complaintReducer.complaint.ecomplaintId;
      let Obj = {
        ecomplaintId: ecomplaintId,
        navigate: navigate,
      };
      dispatch(forceCreateProbableCauseStatement(Obj));
    }
  };


  const onResubmit=()=>{
      if(!complaintMain.complaint.commFailed){
        setShowResubmitComplaintPopup({
          show: true,
          message:"This complaint may have already been submitted. Do you want to resubmit it anyway? ",
          onConfirm:()=>{
            onResubmitComplaintConfirm()
            closeResubmitComplaintPopupClose();
          }});
        }else{
          onResubmitComplaintConfirm()
        }
  }

  const onResubmitComplaintConfirm=()=>{
let _ecCaseDetail = { ...complaintMain };
    let dataObj = {
      _ecCaseDetail,
      fromScheduler: false,
      navigate: navigate,
    };
    dispatch(resubmitComplaint(dataObj));
  }

      const onResubmitFormClick =(ecomplaintId: number, fromScheduler: boolean, formType: string,imageUploadStatus: string,formId: number)=>()=>{
        if(complaintReducer.complaint.commFailed){
          setShowInfoPopup({ show: true, info: `Please submit the complaint before submitting the ${formType} document.`,variant:"danger" })
        }else{
          if(imageUploadStatus=== LF_COMPLAINT_ECFORM_IMAGE_UPLOAD_SUCCESS){
            setShowResubmitComplaintPopup({
          show: true,
             message: `This ${formType} document may have already been submitted. Do you want to resubmit it anyway? `,
          onConfirm:()=>{
            onResubmitFormClickConfirm(ecomplaintId, fromScheduler, formType,formId);
            closeResubmitComplaintPopupClose();
          }});
        }else{
          onResubmitFormClickConfirm(ecomplaintId, fromScheduler, formType,formId);
        }
      }
      }
      
      const onResubmitFormClickConfirm =
      (ecomplaintId: number, fromScheduler: boolean, formType: string,formId: number)=> {
      let dataObj = {
        ecomplaintId: ecomplaintId,
        fromScheduler: fromScheduler,
        formType: formType,
        formId:formId
      };
      // KHL PR 11264 09/01/24 - START
      dispatch(resubmitAccordingToTheFormType(dataObj));
    };


  const backToList = () => {
    navigate(-1);
  };

  let countList = complaintReducer.countList ? complaintReducer.countList : [];

  let defName =
    complaintReducer.complaint.defFirstName +
    " " +
    complaintReducer.complaint.defMiddleName +
    " " +
    complaintReducer.complaint.defLastName +
    " " +
    complaintReducer.complaint.defSuffix;

  let officerName =
    complaintReducer.complaint.officerFirstName?  complaintReducer.complaint.officerFirstName: ""+
    " " +
    complaintReducer.complaint.officerLastName? complaintReducer.complaint.officerLastName: "";

  let remarkFromSupervisor= complaintReducer.complaint.remark ? complaintReducer.complaint.remark : [];  //KHL PR 11594 01/16/25
  // KHL PR 11594 01/21/25 - START
  if (typeof remarkFromSupervisor === "string") {
    try {
      remarkFromSupervisor = JSON.parse(remarkFromSupervisor);
    } catch (error) {
      console.error("Error parsing remark data:", error);
      remarkFromSupervisor = []; 
    }
  }
  // KHL PR 11594 01/21/25 - END

  let eComplaintFormUIs = [];
  let kountRecodes = [];

  let eComplaintFormTypeName = [];

  let allowPreview = false;
  let allowReject = false;
  let allowReturn = false;
  let allowSign = false;
  let allowApprove = false;     // KHL PR 11594 02/10/25
  let allowVoid = false;
  let allowDelete = false;
  let allowAudit = false;
  let allowEdit = false;
  let allowReturnComplaint = false;
  let allowTakeBack = false;
  let allowUnlock = false;
  let allowFileWithCircuitClerk = true;
  let ecomplaintForm;
  let loginUser = loginReducer;   // KHL PR 11594 02/10/25
  let lockBy = "-";
  let complaintMainObject = {};
  let allowResubmit = false;
  let allowResubmitForm = false;
  let allowResubmitComplaint = false;
  let allowGenerateReceipt = false; //KHL PR 11264 09/01/24

  let tableData = complaintReducer.ecFormList.map(
    ({ formId, formTypeName, status, lockBy,imageUploadStatus }: any, i: any) => [
      i,
      (ecomplaintForm = complaintReducer.ecFormList[i]),
      loginUser,    // KHL PR 11594 02/10/25
      formId,
      (formTypeName = formTypeName === LF_ARREST_WARRANT ? formId > 0 ? formTypeName : importFrom === DUCS_CMS_SUPPORT ? LF_BENCH_WARRANT : formTypeName : formTypeName),
      imageUploadStatus,
      status,
      (lockBy =
        ecomplaintForm.lockUserName !== null
          ? ecomplaintForm.lockUserName
          : " - "),
      (allowPreview = isAllowPreview(
        complaintReducer.complaint.caseStatus,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        importFrom
      )),
      (allowReturn = isAllowReturn(
        userType,
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
       importFrom
      )),
      (allowReject = isAllowReject(
        userType,
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
       importFrom
      )),
      (allowSign = isAllowSign(
        userType,
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
        importFrom
      )),
      // KHL PR 11594 02/10/25 - START
      (allowApprove = isAllowApprove(
        userType,
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
        importFrom
      )),
      // KHL PR 11594 02/10/25 - END
      (allowVoid = isAllowVoid(
        userType,
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
        complaintReducer.complaint.caseNumber,
        importFrom
      )),
      (allowDelete = isAllowDelete(
        complaintReducer.complaint.caseStatus,
        userType,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        canDeleteEComplaint,
        importFrom
      )),
      (allowAudit = isAllowAudit(
        ecomplaintForm.formTypeName,
        canViewAuditTrail,
       importFrom
      )),
      (allowEdit = isAllowViewEdit(
        complaintReducer.complaint.caseStatus,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        userType,
        importFrom
      )),
      (allowReturnComplaint = isAllowReturnComplaint(
        userType,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        complaintReducer.complaint.typeOfArrest === TYPE_OF_ARREST_ONVIEWARREST,
        importFrom
      )),
      // (allowResubmit = isAllowResubmit(
      //   ecomplaintForm.status,
      //   ecomplaintForm.formTypeName,
      //   loginReducer.canReSubmitEComplaint,
      //   complaintReducer.countyIntegratedWithCMS,
      //   complaintReducer.preTrialReleaseUploadFailed,
      //   complaintReducer.probableCauseUploadFailed,
      //   importFrom
      // )),
      (allowResubmitForm = isAllowResubmitForm(
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
        loginReducer.canReSubmitEComplaint,
        complaintReducer.countyIntegratedWithCMS,
        complaintReducer.complaint.caseStatus,
      )),
      (allowResubmitComplaint = isAllowResubmitComplaint(
        ecomplaintForm.status,
        ecomplaintForm.formTypeName,
        loginReducer.canReSubmitEComplaint,
        complaintReducer.countyIntegratedWithCMS,
      )),
      (allowGenerateReceipt = isAllowGenerateReceipt(
        complaintReducer.complaint.caseStatus,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        importFrom
      )), //KHL PR 11264 09/01/24
      // (allowTakeBack = isAllowTakeBack(
      //   complaintReducer.complaint.caseStatus,
      //   ecomplaintForm.status,
      //   userType
      // )),
      (complaintMainObject = complaintReducer.complaint),
      handlePreview(
        ecomplaintForm.formTypeName,
        ecomplaintForm.formId,
        ecomplaintForm.status
      ),
      onEditClick(
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        ecomplaintForm.formId,
        ecomplaintForm.ecomplaintId
      ),
      onVoidClick(
        ecomplaintForm.formId,
        ecomplaintForm.ecomplaintId,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status
      ),
      onReturnClick(
        ecomplaintForm.formId,
        ecomplaintForm.ecomplaintId,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status
      ),
      onRejectClick(
        ecomplaintForm.formId,
        ecomplaintForm.ecomplaintId,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status
      ),
      onDeleteClick(
        ecomplaintForm.formId,
        ecomplaintForm.ecomplaintId,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        ecomplaintForm.lockUserName
      ),
      // onResubmitClick(
      //   ecomplaintForm.ecomplaintId,
      //   false,
      //   ecomplaintForm.formTypeName,
      //   formId
      // ),
      onResubmitFormClick(
        ecomplaintForm.ecomplaintId,
        false,
        ecomplaintForm.formTypeName,
        ecomplaintForm.imageUploadStatus,
        formId
      ),
      onReceiptClick(
        ecomplaintForm.formTypeName,
        ecomplaintForm.formId
        ), //KHL PR 11264 09/01/24
      getAuditTrails(
        ecomplaintForm.ecomplaintId,
        ecomplaintForm.formTypeName,
        complaintReducer.complaint.complaintNumber
      ),
      onFilewihClerkClick(),
      submitToJudgeClick(ecomplaintForm.formTypeName),
      (allowEdit = isAllowViewEdit(
        complaintReducer.complaint.caseStatus,
        ecomplaintForm.formTypeName,
        ecomplaintForm.status,
        userType,
        importFrom
      )),
      onResubmit,
    ]
  );

  if (complaintReducer.getComplaintMainStatus === "loading") {
    kountRecodes.push(
      <Row>
        <Col>Loading......</Col>
      </Row>
    );
  } else if (complaintReducer.getComplaintMainStatus === "error") {
    kountRecodes.push(
      <Row>
        <Col>Error Occured</Col>
      </Row>
    );
  } else if (complaintReducer.getComplaintMainStatus === "success") {
    if (complaintReducer.countList!== null && complaintReducer.countList.length === 0) {
      kountRecodes.push(
        <Row>
          <Col>No case records found.</Col>
        </Row>
      );
    } else {
      let caseNumb = "";
      for (let i = 0; i < complaintReducer.countList.length; i++) {
        if (!complaintReducer.multiCaseNumberCounty) {
          if (i === 0) {
            caseNumb = complaintReducer.complaint.caseNumber;
          } else {
            caseNumb = "";
          }
        } else {
          caseNumb = countList[i].caseNumber;
        }
        kountRecodes.push(
          <Row>
            <Col>{caseNumb}</Col>
            <Col md={1}>{countList[i].caseType}</Col>
            <Col md={2}>{countList[i].classOfViolation}</Col>
            <Col md={6}>{countList[i].violationDescription}</Col>
          </Row>
        );
      }
    }
  }

  const formsDropdown = useMemo(() => {
    let list: { formName: any; disabled: boolean; }[] = [];
    const ecForms = complaintReducer.ecFormList || [];
    const createFormList = complaintReducer.createFormList || [];
    list = ecForms
      .filter((item: any) => item.formTypeName !== LF_FORM_TYPE_COMPLAINT)
      .map((item: any) => {
        return {
          formName: item.formTypeName,
          disabled: true,
        };
      });
    list = Array.from(
        new Map(list.map(item => [item.formName, item])).values()
    );
    const complaint = ecForms.find(
      (item: any) => item.formTypeName === LF_FORM_TYPE_COMPLAINT
    );
    const isComplaintFiled =
      complaint && complaint.status
        ? complaint.status === LF_FILED_STATUS
        : false;
    if (
      (userType === ROLE_POLICE_OFFICER || userType === ROLE_AGENCY_ADMIN) &&
      isComplaintFiled
    ) {
let isArrestWarrant: boolean = false;
      createFormList.forEach((item: any) => {
        const isExist = ecForms
          ? ecForms.some((i: any) => i.formTypeName === item.formName)
          : false;
if (item.formName === CREATE_LF_FORM_ARREST_WARRANT) {
          let summonForm = ecForms.find((ecForm: any) => ecForm.formTypeName === CREATE_LF_FORM_SUMMON);
          let summonStatus = "";
          if (summonForm) summonStatus = summonForm.status;
          if (isExist) isArrestWarrant = true;
          else if (!isExist) {
            if(!summonForm){
              list.push({
                formName: item.formName,
                disabled: false
              });
            }else if(summonForm && summonStatus === LF_SIGNED_STATUS){
              list.push({
                formName: item.formName,
                disabled: false
              });
            }
          }
        } else if (item.formName === CREATE_LF_FORM_SUMMON) {
          if (!isArrestWarrant && !isExist) {
            list.push({
              formName: item.formName,
              disabled: false
            });
          }
        } else if (item.formName !== CREATE_LF_FORM_ARREST_WARRANT && item.formName !== CREATE_LF_FORM_SUMMON) {
        if (!isExist) {
          if (item.formName === REVISED_PROBABLE_CAUSE_STATEMENT) {
            if (
              userType === ROLE_POLICE_OFFICER ||
              userType === ROLE_AGENCY_ADMIN
            ) {
              if (
                complaintMainReducer.complaint.postSafeTAct &&
                !complaintMainReducer.complaint.defendantReleased
              ) {
                list.push({
                  formName: item.formName,
                  disabled: false,
                });
              }
            }
          } else {
            list.push({
              formName: item.formName,
              disabled: false,
            });
}
          }
          else if (item.formName === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE) {
            let isAlreadyAdded = list.some(item => item.formName === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE)
            if (isAlreadyAdded)
              list = list.map(el => el.formName === PRE_TRIAL_RELEASE_ON_OWN_RECOGNIZANCE ? { formName: item.formName, disabled: false, } : el);
            else
              list.push({
                formName: item.formName,
                disabled: false,
              });
          }
        }
      });
    }

    return list;
  }, [complaintReducer.createFormList, complaintReducer.ecFormList, userType]);

  // if (complaintReducer.createFormList.length > 0) {
  //   for (const element of complaintReducer.createFormList) {
  //     ecomplaintForm = element;
  //     const disabled =
  //       complaintReducer.ecFormList instanceof Array
  //         ? complaintReducer.ecFormList.some(
  //             (item) => item.formTypeName === element.formTypeName
  //           )
  //         : false;
  //     if (disabled) {
  //       eComplaintFormTypeName.push(
  //         <div>
  //           <span>{element.formTypeName} </span>{" "}
  //         </div>
  //       );
  //     } else {
  //       eComplaintFormTypeName.push(
  //         <div
  //           role="button"
  //           onClick={handleFormLinkClick(CREATE_LF_FORM_ARREST_WARRANT)}
  //         >
  //           <span className="text-info">
  //             <RiCheckFill /> {element.formTypeName}{" "}
  //           </span>{" "}
  //         </div>
  //       );
  //     }
  //     if (ecomplaintForm.formTypeName !== LF_FORM_TYPE_COMPLAINT) {

  //     } else if (userType === ROLE_ADMINISTRATOR) {
  //       eComplaintFormTypeName.push(
  //         <span>
  //           <span className="text-danger">
  //             <RiLink /> Access Logs{" "}
  //           </span>
  //           |{" "}
  //         </span>
  //       );
  //     }
  //   }
  // }

  if (
    (userType === ROLE_POLICE_OFFICER || userType === ROLE_AGENCY_ADMIN) &&
    complaintReducer.complaint.caseStatus === LF_FILED_STATUS
  ) {
    let isExistFormName = false;
    for (const element of complaintReducer.ecFormList) {
      if (element.formTypeName === CREATE_LF_FORM_ARREST_WARRANT) {
        isExistFormName = true;
      }
    }
    if (!isExistFormName) {
      eComplaintFormTypeName.push(
        <div
          role="button"
          onClick={handleFormLinkClick(CREATE_LF_FORM_ARREST_WARRANT)}
        >
          <span className="text-info">
            <RiCheckFill /> {CREATE_LF_FORM_ARREST_WARRANT} |{" "}
          </span>
        </div>
      );
    }
  }

  let officerPhone = complaintReducer.officerPhone;
  let newOfficerPhone;
  if (officerPhone!== null && officerPhone.includes("X")) {
    let phoneNum = officerPhone.split("X");
    newOfficerPhone = phoneNum[0];
  } else {
    newOfficerPhone = officerPhone;
  }

  let listName = userType === ROLE_JUDGE ? "Warrant List" : "Complaint List";

  let itemLinkList = [
    { itemLink: "/", itemName: "DashBoard" },
    {
      itemLink:
        "/" + dashboardReducer.PreviousURLLFC.replace(/^.*\/\/.*?\//, ""),
      itemName: listName,
      itemFunction: onBreadcrumbClick,
    },
  ];

  //KHL PR 11594 01/16/25 - START
  const submitRemark = (remark: string, remarkFor: string) => {
    if ("RETURN" === remarkFor) {
      returnForm(remark)();
    }
  };
  //KHL PR 11594 01/16/25 - END

  // KHL PR 11594 02/10/25 - START
  useEffect (() => {
    const ecFormList = complaintMainReducer.ecFormList;
    const arrestWarrantForm = ecFormList.find(
      (form: any) => form.formTypeName === "Arrest Warrant"
    );
    if(arrestWarrantForm && arrestWarrantForm.formId != null){
      dispatch(fetchArrestWarrant(arrestWarrantForm.formId));
    }
  }, [complaintMainReducer])

  const confirmSubmitToJudgeClick = () => {
    if (approvingFormType === LF_ARREST_WARRANT) {
      dispatch(
        saveArrestWarrant({
          arrestWarrantObj: arrestWarrantReducer.arrestWarrantObj,
          status: LF_COMPLETE_STATUS,
          ecomplaintId: ecomplaintReducer.complaint.ecomplaintId,
          navigate: navigate,
        })
      );
    } else {
      const ecFormList = complaintMainReducer.ecFormList;
      const summonForm = ecFormList.find(
        (form: any) => form.formTypeName === CREATE_LF_FORM_SUMMON
      );

      let data = {
        formId: summonForm ? summonForm.formId : 0,
        formType: CREATE_LF_FORM_SUMMON,
        ecomplaintId: ecomplaintReducer.complaint.ecomplaintId,
        status: LF_SEND_TO_JUDGE_STATUS,
        actionType: 'ignoreSummonData',
        formData: summonWarrantReducer.summonsDataObject,
        navigate: navigate,
      };
      dispatch(editComplaintFromSummons(data));
    }
    
    setShowSubmitToJudge(false);
  };

  const onFileWithCircuitClerkClick = () => {
    setFillingProcessConfirmationModalShow(false);
    let dataObj = {
      ecomplaintId: complaintReducer.complaint.ecomplaintId,
      navigate: navigate,
    };
    dispatch(fileWithCircuitClerk(dataObj));
  };
  // KHL PR 11594 02/10/25 - END


  return (
    <>
      <Header headerName="Long Form Complaints" />
      <div className="main-body p-3">
        <BreadcrumbComponent
          itemList={itemLinkList}
          itemActive="Existing Forms"
        />

        <ErrorMessageAlert
          messages={errorMessageAlert.messages}
          clearError={errorMessageAlert.clearError}
        />

        <AlertMessage
          message={successMessageVal || ""}
          onClose={() => {
            setSuccessMessageVal("");
          }}
        />
        <AlertMessage
          message={statechangeMsgVal || ""}
          onClose={() => {
            setStatechangeMsgVal("");
          }}
        />
        <Row>
          <Col md={8} className="mt-3">
            <Card className="shadow">
              <Card.Body>
                <h4>Case Information</h4>
                <hr className="hrStyle" />
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col md={6} className="fw-bold">
                        Complaint Number
                      </Col>
                      <Col md={6}>
                        {complaintReducer.complaint.complaintNumber}
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={6} className="fw-bold">
                        Report/Incident No
                      </Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.complaint.primaryAgencyRepNumber}
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={6} className="fw-bold">
                        Case Status
                      </Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.complaint.caseStatus}
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col className="fw-bold">State's Attorney Approval</Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.approvedSAInitial}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={6} className="fw-bold">
                        Defendant
                      </Col>
                      <Col md={6}>{defName}</Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={6} className="fw-bold">
                        County
                      </Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.complaint.countyName}
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={6} className="fw-bold">
                        Arresting Agency
                      </Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.complaint.officerAgencyName}
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={6} className="fw-bold">
                        Impounded
                      </Col>
                      <Col md={6} className="text-secondary">
                        {complaintReducer.complaint.impoundWarrant
                          ? "Yes"
                          : "No"}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <hr className="hrStyle" />
                    <Row>
                      <Col md={3}>
                        <span className="fw-bold">Case Number</span>
                      </Col>
                      <Col md={1}>
                        <span className="fw-bold">Type</span>
                      </Col>
                      <Col md={2}>
                        <span className="fw-bold">Class</span>
                      </Col>
                      <Col md={5}>
                        <span className="fw-bold">Charge</span>
                      </Col>
                    </Row>
                    <hr className="hrStyle" />
                    <div
                      style={{
                        maxHeight: "200px",
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {kountRecodes}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mt-3">
            <Card className="shadow">
              <Card.Body>
                <h4>Officer Information</h4>
                <hr className="hrStyle" />
                <Row>
                  <Col md={4} className="fw-bold">
                    Name
                  </Col>
                  <Col md={8}>{officerName}</Col>
                </Row>
                <hr className="hrStyle" />
                <Row>
                  <Col md={4} className="fw-bold">
                    Email
                  </Col>
                  <Col md={8} className="text-secondary">
                    {complaintReducer.complaint.ecOfficerUserProfileEmail
                      ? complaintReducer.complaint.ecOfficerUserProfileEmail
                      : "-"}
                  </Col>
                </Row>
                <hr className="hrStyle" />
                <Row>
                  <Col md={4} className="fw-bold">
                    Phone
                  </Col>
                  <Col md={8} className="text-secondary">
                    {complaintReducer.complaint.ecOfficerUserProfilePhone
                      ? complaintReducer.complaint.ecOfficerUserProfilePhone
                      : "-"}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <br />
            {/* KHL PR 11594 01/21/25 - START */}
            {userType == ROLE_POLICE_OFFICER 
            && (complaintMainReducer.complaint.caseStatus == LF_STATUS_PENDING_SUPERVISOR_RETURNED 
              || (complaintMainReducer.complaint.caseStatus.includes("RETURN"))
              || (complaintMainReducer.ecFormList && complaintMainReducer.ecFormList.find(
                (item: any) => (item.status && item.status.includes("RETURN"))
              )))
            && remarkFromSupervisor.length != 0 ?            
            <Card className="shadow">
              <Card.Body>
                <h4>Remarks</h4>
                <hr className="hrStyle" />
                <Row>
                <Col>
                {Array.isArray(remarkFromSupervisor) && remarkFromSupervisor.length > 0 ? (
                  remarkFromSupervisor.map((item, index) => (
                    item.remark && item.remark.trim() !== "" ? ( 
                      <>
                        <Row key={index}>
                          <Col md={4} className="fw-bold">
                          {new Date(item.timestamp).toLocaleDateString("en-US")} 
                          {" "}
                          {new Date(item.timestamp).toLocaleTimeString("en-US", { hour12: false })}
                          </Col>
                          <Col md={8} className="text-danger">
                            {item.remark}
                          </Col>
                        </Row>
                        <hr className="hrStyle" />
                      </>
                    ) : null 
                  ))
                ) : null}
                </Col>
                </Row>
              </Card.Body>
            </Card>
            : ""
            }
            {/* KHL PR 11594 01/21/25 - END */}
            {/* <Card className="shadow mt-1">
              <Card.Body>
                <h4>Create Forms</h4>
                {eComplaintFormTypeName.length > 0 ? (
                  <Row>
                    <hr className="hrStyle" />
                    <Col md={12} className="fw-bold">
                      {eComplaintFormTypeName}
                    </Col>
                  </Row>
                ) : (
                  <div>
                    <hr className="hrStyle" />
                    <Row>
                      <Col>N/A</Col>
                    </Row>
                  </div>
                )}
              </Card.Body>
            </Card> */}
          </Col>
        </Row>

        <Card className="shadow mt-3">
          <Card.Body>
            <Row>
              <Col xs="auto">
                <ButtonComponent onClick={backToEcomplaintList}>
                  <RiArrowLeftLine />
                  {userType === ROLE_JUDGE
                    ? "Back to Warrant List"
                    : "Back to Complaint List"}
                </ButtonComponent>
              </Col>
              <Col className="mt-3" xs={3}>
                <h4>Existing Forms</h4>
              </Col>
              <Col className="text-end">
                <ButtonComponent
                  variant="info"
                  onClick={showVideoConferenceModal}
                >
                  <RiVideoChatFill /> Video Conference
                </ButtonComponent>{" "}
                {userType === ROLE_ADMINISTRATOR && (
                  <ButtonComponent
                    variant="info"
                    className="me-1"
                    onClick={showAuditTrailModal}
                  >
                    <RiFileCopy2Fill /> Access Logs
                  </ButtonComponent>
                )}
                {formsDropdown.length > 0 && (
                  <Dropdown className="d-inline-block">
                    <Dropdown.Toggle
                      id="dropdown-button-dark-example1"
                      variant="secondary"
                    >
                      Create Forms
                    </Dropdown.Toggle>

                    <Dropdown.Menu variant="dark">
                      {formsDropdown.map((form: any, i: number) => {
                        return (
                          <Dropdown.Item
                            key={i}
                            eventKey={i}
                            disabled={form.disabled}
                            className={form.disabled ? "opacity-50" : ""}
                            onClick={handleFormLinkClick(form.formName)}
                          >
                            {form.formName}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
                &nbsp;
                {ROLE_JUDGE === userType || ROLE_COUNTY_ADMIN === userType ? (
                  <ButtonComponent variant="info" onClick={refreshPage}>
                    <FiRefreshCcw /> Refresh
                  </ButtonComponent>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            {/* <Row>
              {ROLE_JUDGE === userType ? (
                <Col xs="auto">
                  <Link to={"/WarrantList"}>
                    <ButtonComponent>
                      <RiArrowLeftLine /> Back to Complaint List
                    </ButtonComponent>
                  </Link>
                </Col>
              ) : (
                <Col xs="auto">
                  <Link to={"/SearchEComplaint"}>
                    <ButtonComponent>
                      <RiArrowLeftLine /> Back to Complaint List
                    </ButtonComponent>
                  </Link>
                </Col>
              )}
              <Col xs="auto">
                <ButtonComponent onClick={backToList}>
                  <RiArrowLeftLine /> Back to Complaint List
                </ButtonComponent>
              </Col>
              <Col className="mt-3" xs={3}>
                <h4>Existing Forms</h4>
              </Col>
              <Col className="text-end">
                <ButtonComponent
                  variant="info"
                  onClick={showVideoConferenceModal}
                >
                  <RiVideoChatFill /> Video Conference
                </ButtonComponent>
              </Col>
            </Row> */}
            {/* {ROLE_JUDGE === userType ? (
              <Row>
                <Col className="text-end">
                  <ButtonComponent variant="info" onClick={refreshPage}>
                    <FiRefreshCcw />
                  </ButtonComponent>
                </Col>
              </Row>
            ) : (
              ""
            )} */}
            <TableComponent
              tableHeader={tableHeader}
              tableData={tableData}
              renderTableRow={renderTableRow}
            />
          </Card.Body>
        </Card>

        <ConfirmPopup
          children={confirmText}
          show={confirmPopupData.show}
          onHide={() =>
            setconfirmPopupData({
              show: false,
              ecObj: {},
            })
          }
          isConfirmation={handleConfirmation}
        />

      {/*KHL PR 11594 02/10/25 - START*/}
      {/*KHL PR 11814 09/01/2025 - START*/}
      <ConfirmPopup
        children={
          <>We are currently unable to communicate with the <b>Clerk's Case Management System</b>. Do you still want to <b>proceed and file the Release on Personal Recognizance form</b> despite this connection issue?</>
          
        }
        show={showPreTrialInfoPopup}
        onHide={() => setShowPreTrialInfoPopup(false)}
        isConfirmation={handlePreTrialPopUp}
      />
      {/*KHL PR 11814 09/01/2025 - END*/}

      <ConfirmPopup
        children={
          approvingFormType === LF_ARREST_WARRANT
          ? "You are about to submit this complaint and arrest warrant to the Judge for signature."
          : "You are about to submit this complaint and summon to the Judge for signature."
        }
        show={showSubmitToJudge}
        onHide={() => setShowSubmitToJudge(false)}
        isConfirmation={confirmSubmitToJudgeClick}
      />

        <ConfirmPopup
              children={
                showResubmitComplaintPopup?.message||"Are you sure you want to resubmit?"
              }
              show={showResubmitComplaintPopup?.show||false}
              onHide={showResubmitComplaintPopup?.onCancel || closeResubmitComplaintPopupClose}
              isConfirmation={showResubmitComplaintPopup?.onConfirm || (() => {})}
            />


      {(fillingProcessConfirmationModalShow) && (
        <OptionPopup
          show={fillingProcessConfirmationModalShow}
          header={""}
          children={
            <div className="text-start">
              Once filed, a case cannot be updated or deleted.<br></br>
              <br></br>
              Do you want to file the case with the circuit clerk, or return to
              the Case Complaint Screen?
            </div>
          }
          buttons={[
            {
              name: "Return",
              variant: "danger",
              onClick: () => {
                setFillingProcessConfirmationModalShow(false);
              },
            },
            {
              name: "File with Circuit Clerk",
              variant: "primary",
              onClick: onFileWithCircuitClerkClick,
            },
          ]}
        />
      )}
      {/*KHL PR 11594 02/10/25 - END*/}

        <InfoPopup
          children={showInfoPopup.info}
          onHide={() => setShowInfoPopup({ show: false, info: "", variant: "info" })}
          show={showInfoPopup.show}
          variant={
            showInfoPopup.variant === "info" ||
            showInfoPopup.variant === "success" ||
            showInfoPopup.variant === "danger" ||
            showInfoPopup.variant === "warning"
              ? showInfoPopup.variant
              : "info"
          }
        />

        <VideoConferenceSplitScreenPopUp
          show={showVideoConference}
          onHide={onHide}
          isTestWebCam={false}
        />
        {/* KHL PR 11594 01/16/25 - START */}
        <RemarkPopup
        show={remarkModalShow}
        onHide={() => setRemarkModalShow(false)}
        submitRemark={submitRemark}
        remarkFor={remarkFor}
        action={action}
        remarkRequired={remarkRequired}
        onlyView={onlyView}
        remarksForView={viewRemark}
        isEditClick={isEditClick}
      />
      {/* KHL PR 11594 01/16/25 - END */}
        {
          showAuditTrail &&
          <AuditTrialPopup
            showAuditTrail={showAuditTrail}
            onHide={cancelAuditTrailModal}
            searchwarrantid={searchWarrantIdForAuditTrail}
            formType={formTypeForAuditTrail}
            caseNumber={caseNumberForAuditTrail}
            auditType={auditType}
          />
        }
      </div>
    </>
  );
};

const renderTableRow = (row: any[]) => {
  const [
    i,
    ecomplaintForm,
    loginUser,      //KHL PR 11594 02/10/25
    formId,
    formTypeName,
    imageUploadStatus,
    status,
    lockBy,
    allowPreview,
    allowReturn,
    allowReject,
    allowSign,
    allowApprove,   //KHL PR 11594 02/10/25
    allowVoid,
    allowDelete,
    allowAudit,
    allowEdit,
    allowReturnComplaint,
    allowResubmitForm,
    allowResubmitComplaint,
    allowGenerateReceipt, //KHL PR 11264 09/01/24
    // allowTakeBack,
    complaintMainObject,
    handlePreview,
    onEditClick,
    onVoidClick,
    onReturnClick,
    onRejectClick,
    onDeleteClick,
    onResubmitFormClick,
    onReceiptClick,   //KHL PR 11264 09/01/24
    getAuditTrails,
    onFilewihClerkClick,      //KHL PR 11594 02/10/25
    submitToJudgeClick,     //KHL PR 11594 02/10/25
    isEditable=allowEdit ,
    onResubmit,
  ] = row;
  return (
    <tr key={formId}>
      <td>{i + 1}</td>
      <td>
        {isEditable ? (
          <a role="button" className="link-info" onClick={onEditClick}>
            {formTypeName}
          </a>
        ) : (
          formTypeName
        )}
      </td>
      <td>{status}</td>
      <td>{lockBy}</td>
      <td className="justify-content-center d-flex align-items-stretch">
        {allowPreview ? (
          <TableActionComponent
            tootltip="Preview"
            children={<RiFileTextLine />}
            actionFunction={handlePreview}
            color="text-info"
            text="Preview"
          />
        ) : (
          ""
        )}

        {/* {allowSubmit ? (
          <TableActionComponent
            tootltip={
              submitImage === "submit-to-judge"
                ? "Submit to Judge"
                : "Submit for Screening"
            }
            children={
              submitImage === "submit-to-judge" ? (
                <RiArrowRightFill />
              ) : (
                <RiSendPlane2Fill />
              )
            }
            actionFunction={onSubmitClick}
            color="text-danger"
          />
        ) : (
          ""
        )} */}

        {allowEdit ? (
          <TableActionComponent
            tootltip={status === LF_FILED_STATUS ? "Open" : "Edit"}
            children={
              status === LF_FILED_STATUS ? <RiShareBoxFill /> : <RiDraftFill />
            }
            actionFunction={onEditClick}
            text={status === LF_FILED_STATUS ? "Open" : "Edit"}
          />
        ) : (
          ""
        )}

        {allowSign ? (
          <TableActionComponent
            tootltip="Sign"
            children={<FaFileSignature />}
            actionFunction={onEditClick}
            color="text-success"
            text="Sign"
          />
        ) : (
          ""
        )}

        {allowVoid ? (
          <TableActionComponent
            tootltip="Void"
            children={<RiCloseCircleFill />}
            actionFunction={onVoidClick}
            color="text-danger"
            text="Void"
          />
        ) : (
          ""
        )}

        {allowReturn ? (
          <TableActionComponent
            tootltip="Return to Officer"
            children={<RiArrowGoBackFill />}
            actionFunction={onReturnClick}
            color="text-info"
            text="Return to Officer"
          />
        ) : (
          ""
        )}
        {/* KHL PR 11594 02/10/25 - START */}
        {allowApprove ? (
          <TableActionComponent
            tootltip="Submit to Judge"
            children={<RiFileTransferFill />}
            actionFunction={submitToJudgeClick}
            color="text-success"
            text="Approve"
          />
        ) : (
          "")}
        {/* KHL PR 11594 02/10/25 - END */}
        {allowReturnComplaint ? (
          <TableActionComponent
            tootltip="Return to Officer"
            children={<RiArrowGoBackFill />}
            actionFunction={onReturnClick}
            color="text-info"
            text="Return to Officer"
          />
        ) : (
          ""
        )}

        {allowReject ? (
          <TableActionComponent
            tootltip="Reject"
            children={<BsSlashCircle />}
            actionFunction={onRejectClick}
            color="text-danger"
            text="Reject"
          />
        ) : (
          ""
        )}

        {allowDelete ? (
          <TableActionComponent
            tootltip="Delete"
            children={<RiWindow2Fill />}
            actionFunction={onDeleteClick}
            color="text-info"
            text="Delete"
          />
        ) : (
          ""
        )}

        {allowAudit ? (
          <TableActionComponent
            tootltip="Audit Trail"
            children={<RiFile2Fill />}
            actionFunction={getAuditTrails}
            color="text-success"
            text="Audit Trail"
          />
        ) : (
          ""
        )}

        {/* {allowTakeBack ? (
          <TableActionComponent
            tootltip="Take Back"
            children={<RiArrowGoBackLine />}
            actionFunction={onEditClick}
            color="text-success"
          />
        ) : (
          ""
        )} */}

        {/* KHL PR 11594 02/10/25 - START */}
        {complaintMainObject.certificationIndicator &&
        (loginUser.userType === ROLE_AGENCY_ADMIN 
        && complaintMainObject.caseStatus === LF_STATUS_PENDING_SUPERVISOR_REVIEW
        && complaintMainObject.typeOfArrest === TYPE_OF_ARREST_ONVIEWARREST
          ) ||
          (loginUser.userType === ROLE_POLICE_OFFICER 
            && complaintMainObject.caseStatus === LF_PENDING_STATUS
            && complaintMainObject.typeOfArrest === TYPE_OF_ARREST_ONVIEWARREST
            && !loginUser.ecUserAgency.isComplaintSupervised
          )
             ? (
          <TableActionComponent
            tootltip="FileWithCircuitClerk"
            children={<RiMapPinLine />}
            actionFunction={onFilewihClerkClick}
            color="text-info"
            text="File With Circuit Clerk"
          />
        ) : (
          ""
        )}
        {/* KHL PR 11594 02/10/25 - END */}
{/* 
        {allowResubmit ? (
          <TableActionComponent
            tootltip={"reSubmit"}
            children={<RiFile2Fill />}
            actionFunction={onResubmitClick}
            color="text-info"
            text="reSubmit"
          />
        ) : (
          ""
        )} */}

      
        {/* KHL PR 11264 09/01/24 - START */}
        {allowGenerateReceipt ? (
          <TableActionComponent
            tootltip={"Generate Receipt"}
            children={<FaReceipt />}
            actionFunction={onReceiptClick}
            color="text-info"
            text="Receipt"
          />
        ) : (
          ""
        )}
        {/* KHL PR 11264 09/01/24 - END */}

        {allowResubmitComplaint &&  (
          <TableActionComponent
            tootltip={`Resubmit Complaint`}
            children={<FaRetweet />}
            actionFunction={onResubmit }
            color={!complaintMainObject?.commFailed?"text-success":"text-danger"}
            text="Resubmit"
          />
        )}

        {allowResubmitForm && (
          <TableActionComponent
            tootltip={`Resubmit ${formTypeName}`}
            // children={<RiFile2Fill />}
            children={<FaRetweet />}
            actionFunction={onResubmitFormClick}
            // color="text-info"
            color={imageUploadStatus === LF_COMPLAINT_ECFORM_IMAGE_UPLOAD_SUCCESS ? "text-success" : "text-danger"}
            text="Resubmit"
          />
        )}

              
      </td>
    </tr>
  );
};

export default EComplaintDashBoard;
